module.exports = __webpack_public_path__ + "img/down-arrow-light-sharp.d37675c7.png";